'use client';
import { Class } from '@/types';
import Button from '@components/Button';
import Link from 'next/link';
import { useState } from 'react';
import ClassInformation from './ClassInformation';

type Props = { classes: Class[] };

function Classes(props: Props) {
  const { classes } = props;
  const [listSize, setListSize] = useState(5);

  if (!classes.length) return null;

  return (
    <section className='classes' id='classes'>
      <h2 className='classes__title'>Offene Termine</h2>
      <div className='classes__intro'>
        {
          'Wählen Sie Ihren passenden Termin und sichern Sie sich Ihren Platz direkt online. Mit nur einem Klick gelangen Sie zur unkomplizierten Buchung Ihrer Weiterbildung.'
        }
      </div>
      <ol className='classes__list'>
        {classes.slice(0, listSize).map(c => (
          <li key={c.class_id}>
            <Link href={`/order/${c.class_id}`} className='classes__link'>
              <ClassInformation information={c} />
            </Link>
          </li>
        ))}
      </ol>
      {classes.length > 5 && listSize <= 5 ? (
        <Button className='classes__more-button' ghost white onClick={() => setListSize(classes.length)}>
          Alle Termine anzeigen
        </Button>
      ) : null}
    </section>
  );
}

export default Classes;
